import { LogoProps } from "@/data/types";

export default function BrandMark({ className }: LogoProps) {
  return (
    <div className={className}>
      <svg viewBox="0 0 93 98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M83.0998 83.6563H76.7575C76.7575 51.0513 54.8224 22.9808 24.2246 14.3746V0H0L9.9002 14.3129V83.6871L0 98H93V69.4051L83.0998 83.718V83.6563ZM24.2246 83.6563V29.3661C46.7166 37.4479 62.4641 58.9172 62.4641 83.6563H24.2246Z" fill="#EBE1D4"/>
      </svg>
    </div>
  )
}